//#region Imports
import React, { useEffect, useRef, useState } from 'react';
//MUI
import { Backdrop } from '@mui/material';
import AppLoader from '../../../components/AppLoader/AppLoader';
//components
import {
    convertDateDDMMYY, numberFormatting
} from "../../../services/Functions";
//scss
import "../../../style/common.scss";
//urls
import { cfpBaseUrl } from '../../../network/urls';
// use scan detection
import useScanDetection from 'use-scan-detection';
// authorization
// Services
import { tableStyle, tableStyleOverDue } from '../../../style/common';
import ServiceDashboardTables from '../../../components/ServiceDashboardTables/ServiceDashboardTables';
//pdfjs
import { useDispatch, useSelector } from 'react-redux';
import {
    actionableNormal,
    firstPage as firstPageActionableNormal,
    lastPage as lastPageActionableNormal,
    nextPage as nextPageActionableNormal,
    previousPage as prePageActionableNormal
} from '../../../features/actionable/actionableNormalSlice';
import {
    actionableOverdue,
    firstPage as firstPageActionableOverdue,
    lastPage as lastPageActionableOverdue,
    nextPage as nextPageActionableOverdue,
    previousPage as prePageActionableOverdue
} from '../../../features/actionable/actionableOverdueSlice';
import { signOut } from '../../../features/authentication/authenticationSlice';
import useFetchData from '../../../hooks/fetchData';
import InstallmentsTable from '../../BillingAndCollection/Installments/InstallmentsTable';
import DueDateExtensionTable from '../../BillingAndCollection/DueDateExtentsion/DueDateExtensionTable';
import Newconnectiontable from '../../GeneralServices/NewConnection/NewConnectionTable';
import ActionsCell from '../../../components/actionCell/ActionCell';
//#endregion

const ActionablesTable = () => {
    const installmentsTableRef = useRef();
    const dueDateTableRef = useRef();
    const newConnectionTableRef = useRef();

    //#region paginatedlogic
    const dispatch = useDispatch();
    const { pageNumber: currentPageActionableNormal, data: dataActionableNormal, pageSize: pageSizeActionableNormal, totalPages: totalPagesActionableNormal, totalRecords: totalRecordsActionableNormal, error: actionableNormalError } = useSelector((state) => state.actionableNormal);
    const { pageNumber: currentPageActionableOverdue, data: dataActionableOverdue, pageSize: pageSizeActionableOverdue, totalPages: totalPagesActionableOverdue, totalRecords: totalRecordsActionableOverdue, error: actionableOverdueError } = useSelector((state) => state.actionableOverdue);

    const { token, userId, hierarchy, roleId, roleName, permissions,roleTypeId } = useSelector((state) => state.auth)

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    const RequestOptions = (method, myHeaders) => {
        return {
            method: method,
            headers: myHeaders,
            redirect: "follow"
        };
    }

    // useEffect(() => {
    //     if ((actionableNormalError && actionableNormalError === "Failed to fetch")) {
    //         dispatch(signOut())
    //     }
    // }, [actionableNormalError])

    useEffect(() => {
        if ((actionableOverdueError && actionableOverdueError === "Failed to fetch")) {
            dispatch(signOut())
        }
    }, [actionableOverdueError])

    const handleNextPageNormal = () => {
        dispatch(nextPageActionableNormal());
    };

    const handlePreviousPageNormal = () => {
        dispatch(prePageActionableNormal());
    };

    const handleFirstPageNormal = () => {
        dispatch(firstPageActionableNormal());
    };

    const handleLastPageNormal = () => {
        dispatch(lastPageActionableNormal(totalPagesActionableNormal)); // Replace '2' with actual value
    };

    useEffect(() => {
        if (token) {
            setViewBackdrop(true)
            if(roleTypeId == 1){
                dispatch(actionableNormal({ pageNumber: currentPageActionableNormal, pageSize: pageSizeActionableNormal }));
            }
        }
    }, [currentPageActionableNormal, pageSizeActionableNormal]);

    useEffect(() => {
        if (dataActionableNormal) {
            setActionableNormalApplications(dataActionableNormal)
            setViewBackdrop(false)
        }
    }, [dataActionableNormal])

    const handleNextPageOverdue = () => {
        dispatch(nextPageActionableOverdue());
    };

    const handlePreviousPageOverdue = () => {
        dispatch(prePageActionableOverdue());
    };

    const handleFirstPageOverdue = () => {
        dispatch(firstPageActionableOverdue());
    };

    const handleLastPageOverdue = () => {
        dispatch(lastPageActionableOverdue(totalPagesActionableOverdue)); // Replace '2' with actual value
    };

    useEffect(() => {
        if (token) {
            setViewBackdrop(true)
            dispatch(actionableOverdue({ pageNumber: currentPageActionableOverdue, pageSize: pageSizeActionableOverdue }));
        }
    }, [currentPageActionableOverdue, pageSizeActionableOverdue]);

    useEffect(() => {
        if (dataActionableOverdue) {
            setActionableOverDueApplications(dataActionableOverdue)
            setViewBackdrop(false)
        }
    }, [dataActionableOverdue])

    //#endregion

    //#region initial values
    const initialValues = {
        iv_objection_Type: 'No Issue',
        iv_objection_Descripton: '',

        //arrears fields
        iv_property_reference_no: '',

        //arears paid bill document field
        iv_arear_paid_bill_document: '',
        iv_arear_paid_bill_date: '',

        //applied load fields
        iv_applied_load: '',

        //dn fields
        iv_distance: 1,
        iv_estimated_distance: 41,
        iv_sketch_diagram: '',
        iv_coverage_area: '3',
        iv_existing_meters_ref_nos_array: '',
        iv_tariff_to_allot: '',
        iv_surveyed_by: '',
        iv_survey_date: '',
        iv_batch: '',
        iv_reference_to_allot: '',
        iv_industry_factory_type: '',
        iv_bank_name: '',
        iv_connection_account_no: '',
        iv_grid_sharing_cost: 0,
        iv_feeder_rehab_charges: 0,
        iv_civil_work_charges: 0,
        iv_fixed_charges_of_metering: 0,
        iv_miscellaneous_charges: 0,
        iv_less_the_cost: 0,

        // boq fields
        iv_fieldItemId: '',
        iv_fieldItemQty: '',
        iv_fieldItemRate: '',
        iv_fieldItemUnit: '',
        iv_fieldItemAmount: '',
        iv_items_array: '',

        // payment verification fields
        iv_payment_date: '',
        iv_receipt_image: '',

        //sco fields
        iv_fata_pata: '',
        iv_rural_urban: 'U',
        iv_feeder_no: '',
        iv_sub_batch: '',
        iv_fgovt: '',
        iv_cantonment_board: '',
        iv_pgovt: '',
        iv_local_bodies: '',
        iv_authorized_by_name: '',
        iv_date_of_authorization: '',
        iv_store_requisition_no: '',
        iv_store_requisition_date: '',
        iv_sanctioned_load: '',
        iv_seasonal_flag: 1,
        iv_no_of_acs: 0,
        iv_no_of_meters: 0,
        iv_no_of_meter_sets: 0,
        iv_no_of_sub_sets: 0,
        iv_no_ofsupply_points: 0,
        iv_installed_transformer_capacity: '',
        iv_meter_id: '',
        iv_meter_serial_no: '',
        iv_location_code: '',
        iv_meter_code: '',
        iv_manufacturer_code: '',
        iv_multiplying_factor: 1,
        iv_meter_range: '',
        iv_meter_reading: '',
        iv_date_of_connection: '',
        iv_cp_78_item_no: '',
        iv_tie_up_non_tie_up: 1,
        iv_seal_on_meter: '',
        iv_seal_on_box: '',
        iv_security_slip_or_price_bond_no: '',
        iv_connection_installer_name: '',
        iv_meter_type: 0,
        iv_meter_reading_off_peak_kwh: '',
        iv_meter_reading_peak_kwh: '',
        iv_meter_reading_off_peak_kvarh: '',
        iv_meter_reading_peak_kvarh: '',
        iv_ct: '',
        iv_pt: '',
        iv_mdi: '',
        iv_no_of_mdi_resets: '',

        // master data fields
        iv_govt_dept: 0,
        iv_ed_code: '',
        iv_standard_classification_code: '',
        iv_income_tax: 0,
        iv_authority: '',

        //basic info update fields
        iv_applicant_name: '',
        iv_applicant_cnic: '',
        iv_applicant_phone: '',
        iv_applicant_email: '',
        iv_address: '',
        iv_relative_name: '',
        iv_owner_name: '',
        iv_owner_cnic: '',
        iv_owner_phone: '',
        iv_owner_email: '',
        iv_city_district: "",
        iv_meter_installed: 0,
        iv_town_tehsil: "",
        iv_chak_street: "",
        // Urban
        iv_house: "",
        iv_street: "",
        iv_sector_block_phase_mohala: "",
        // Rural
        iv_chak_street: "",
        iv_village: "",
    }

    //#endregion

    //#region get item local storage 
    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
    //#endregion

    //#region states 
    const [viewBackdrop, setViewBackdrop] = useState(false);

    const [actionableNormalApplications, setActionableNormalApplications] = useState([]);
    const [actionableNormalApplicationsToDataGrid, setActionableNormalApplicationsToDataGrid] = useState([]);
    const [actionableOverDueApplications, setActionableOverDueApplications] = useState([]);
    const [actionableOverDueApplicationsToDataGrid, setActionableOverDueApplicationsToDataGrid] = useState([]);

    //#endregion

    //#region constants / variables 

    const tblColumns = [
        { field: "applicationId", type: 'text', sortable: false, filterable: false, headerName: 'Application No.', align: 'center', headerStyle: { ...tableStyle.headerStyle, width: '3000px' }, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "creationDate", type: 'date', sortable: false, filterable: true, headerName: 'Date', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "applicantName", headerName: 'Applicant Name', sortable: false, filterable: false, type: 'text', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "applicationTypeName", type: 'text', sortable: false, filterable: false, headerName: 'Type', align: 'left', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: '12px' } },
        {
            headerName: "Docs.",
            disableColumnMenu: true,
            sortable: false,
            filterable: false,
            flex: 1,
            filterable: false,
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: { ...tableStyle.rowCellStyle, fontSize: '15px' },
            field: 'downloads',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <ActionsCell data={params} />
                )
            }
        }
    ]

    const tblColumnsOverDue = [
        { field: "applicationId", type: 'text', sortable: false, filterable: false, headerName: 'Application No.', align: 'center', headerStyle: { ...tableStyleOverDue.headerStyle, width: '3000px' }, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: { ...tableStyleOverDue.rowCellStyle, marginLeft: '5px' } },
        { field: "creationDate", type: 'date', headerName: 'Date', sortable: false, filterable: true, align: 'center', headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "applicantName", headerName: 'Applicant Name', sortable: false, filterable: false, type: 'text', align: 'left', disableColumnMenu: true, sortable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "applicationTypeName", type: 'text', sortable: false, filterable: false, headerName: 'Type', align: 'left', headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: '12px' } },
        { field: "exceededDuration", type: 'text', sortable: false, filterable: false, headerName: 'Days', align: 'center', headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: { ...tableStyleOverDue.rowCellStyle, color: 'red', minWidth: '20px' } },
        {
            headerName: "Docs.",
            disableColumnMenu: true,
            sortable: false,
            filterable: false,
            flex: 1,
            filterable: false,
            headerStyle: tableStyleOverDue.headerStyle,
            headerCellStyle: tableStyleOverDue.headerCellStyle,
            rowCellStyle: { ...tableStyleOverDue.rowCellStyle, fontSize: '15px' },
            field: 'downloads',
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                return (
                    <ActionsCell data={params} />
                )
            }
        }
    ]

    //#endregion

    //#region api function

    //#endregion

    //#region functions

    useScanDetection({
        onComplete: async (code) => {
            if (code) {
                code = code.replace(/Shift/g, '');
                const regex = /^[A-Z]{2}-\d{14,15}$/;
                if (regex.test(code)) {
                    await handleRowClick(code);
                } else {
                }
            }
        },
        minLength: 4, // EAN13
    });

    const apiToDataGridConversionNormal = async () => {
        try {
            const tempArray = []
            if (actionableNormalApplications) {
                actionableNormalApplications.forEach((item) => {
                    let dataGridObject = {}
                    if (item.applicationId) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDateDDMMYY(item.creationDate),
                            "applicantName": item.applicantName,
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": progFunc(item.applicationProgressId),
                            "applicationProgressNumber": item.applicationProgressId,
                            "inTime": item.inTime,
                            "exceededDuration": item.exceededDuration,
                            "releventApplicationFlage": item.releventApplicationFlage,
                            "applicationTypeName": item.applicationTypeName,
                            "applicationTypeId": item.applicationTypeId
                        }

                        tempArray.push(dataGridObject)
                    }
                })
            }
            else {
                const dataGridObject = {
                    "applicationId": ' ',
                    "connectionType": '',
                    "applicantName": ' ',
                    "applicantCNIC": ' ',
                    "applicationStatusId": statusFunc(' '),
                }
                tempArray.push(dataGridObject)
            }

            setActionableNormalApplicationsToDataGrid(tempArray);
            setViewBackdrop(false)
        }
        catch (e) {
        }
    }

    const apiToDataGridConversionOverdue = async () => {
        try {
            const tempArray = []
            if (actionableOverDueApplications) {
                actionableOverDueApplications.forEach((item) => {
                    let dataGridObject = {}
                    if (item.applicationId) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDateDDMMYY(item.creationDate),
                            "applicantName": item.applicantName,
                            "applicationProgressNumber": item.applicationProgressId,
                            "inTime": item.inTime,
                            "exceededDuration": item.exceededDuration,
                            "releventApplicationFlage": item.releventApplicationFlage,
                            "applicationTypeName": item.applicationTypeName,
                            "applicationTypeId": item.applicationTypeId
                        }
                        tempArray.push(dataGridObject)
                    }
                })
            }
            else {
                const dataGridObject = {
                    "applicationId": ' ',
                    "connectionType": '',
                    "applicantName": ' ',
                    "applicantCNIC": ' ',
                    "applicationStatusId": statusFunc(' '),
                }
                tempArray.push(dataGridObject)
            }

            setActionableOverDueApplicationsToDataGrid(tempArray);
            setViewBackdrop(false)
        }
        catch (e) {
        }
    }

    const statusFunc = (x, objection) => {
        if (objection === 0 || objection === 2) {
            if (x === 0) {
                return 'Pending'
            }
            else if (x > 0 && x < 5) {
                return 'In Process'
            }
            else if (x >= 5 && x < 10) {
                return 'Approved'
            }
            else {
                return 'Completed'
            }
        }
        else {
            return 'Objection'
        }
    }

    const progFunc = (x) => {
        if (x === 0) {
            return 'Documents Uploading'
        }
        else if (x === 1) {
            return 'Documents Verification'
        }
        else if (x === 2) {
            return 'Arrear Verification'
        }
        else if (x === 3) {
            return 'Field Survey'
        }
        else if (x === 4) {
            return 'Reference No. Allocation'
        }
        else if (x === 5) {
            return 'Demand Note Payment'
        }
        else if (x === 6) {
            return 'DN Payment Verification'
        }
        else if (x === 7) {
            return 'Service Connection Order'
        }
        else if (x === 8) {
            return 'Meter Installation'
        }
        else if (x === 9) {
            return 'Ready for Billing'
        }
        else if (x === 10) {
            return 'Completed'
        }
    };

    const handleRowClick = async (params) => {
        setViewBackdrop(true);
        if (params.applicationTypeId == 8) {
            installmentsTableRef.current.handleRowClick(params.applicationId);
        } else if (params.applicationTypeId == 7) {
            dueDateTableRef.current.handleRowClick(params.applicationId)
        } else if (params.applicationTypeId == 1) {
            newConnectionTableRef.current.handleRowClick(params.applicationId)
        }
        setViewBackdrop(false);
    };

    //#endregion

    //#region useEffects

    useEffect(() => {
        if (actionableNormalApplications) {
            apiToDataGridConversionNormal();
        }
    }, [actionableNormalApplications]);

    useEffect(() => {
        if (actionableOverDueApplications) {
            apiToDataGridConversionOverdue()
        }
    }, [actionableOverDueApplications]);

    //#endregion

    return (
        <>
            <ServiceDashboardTables
                enabled
                isLoadingNormal={viewBackdrop}
                isLoadingOverdue={viewBackdrop}
                normalTitle={`Actionables ( ${numberFormatting(totalRecordsActionableNormal) ? numberFormatting(totalRecordsActionableNormal) : "-"} )`}
                overdueCount={numberFormatting(totalRecordsActionableOverdue) ? numberFormatting(totalRecordsActionableOverdue) : "-"}
                normalColumns={tblColumns}
                overdueColumns={tblColumnsOverDue}
                normalData={actionableNormalApplicationsToDataGrid}
                overdueData={actionableOverDueApplicationsToDataGrid}
                onRowClick={handleRowClick}
                passRowOnClick
                mobileFields={["applicationId", "applicantName", "applicationStatusId"]}
                normalTableProps={{
                    firstPage: handleFirstPageNormal,
                    lastPage: handleLastPageNormal,
                    totalPages: totalPagesActionableNormal,
                    totalRecords: totalRecordsActionableNormal,
                    currentPage: currentPageActionableNormal,
                    nextPage: handleNextPageNormal,
                    previousPage: handlePreviousPageNormal,
                }}
                overdueTableProps={{
                    firstPage: handleFirstPageOverdue,
                    nextPage: handleNextPageOverdue,
                    previousPage: handlePreviousPageOverdue,
                    lastPage: handleLastPageOverdue,
                    totalPages: totalPagesActionableOverdue,
                    totalRecords: totalRecordsActionableOverdue,
                    currentPage: currentPageActionableOverdue,
                }}
            />

            <InstallmentsTable ref={installmentsTableRef} />
            <DueDateExtensionTable ref={dueDateTableRef} />
            <Newconnectiontable ref={newConnectionTableRef} />

            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >

        </>
    )
}

export default ActionablesTable;